import React, {Component} from "react";
import "./AboutMe.css";

<link
href="https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,600italic,300italic,400italic,300,700italic,800italic,800"
rel="stylesheet"></link>

class AboutMe extends Component{

	state={
		erosboo:false,
		shawhien:false
	}

	handleClick=(event)=>{
		const {name} = event.target;
		if(this.state[name]){
			this.setState({[name]:false})	
		}
		if(!this.state[name]){
			this.setState({[name]:true})
		}
	}

	render(){
		return(
			<section className="section indigo lighten-5 center">
				<div className="container">
					<div className="revealThis card-panel white z-depth-1 about-me-top-margin">
						<div className="row no-margin">
							<div className="col s12 m6 l3 valign-wrapper">
								<img src="/assets/img/me.jpg" alt="" className={this.state.shawhien?"circle responsive-img animated infinite rotate360":"circle responsive-img"} name="shawhien" onClick={this.handleClick} />
							</div>
							<div className="col s12 m6 l6 center">
								<h4 className="no-margin">About <strong className="indigo-text">Me</strong></h4>
								<div className= "left-align">

								<p className="">
									Hi! I&apos;m Shawhien Sohrabi. I am a full-stack developer currently living in Seattle, WA.
								</p>
								<p className="">
									My keen attention to detail and dedication to solving any problem thrown at me with a level head help me strive as a full-stack developer.
								</p>
								<p className="hide-on-med-only hide-on-small-only">
									Outside of coding, I spend a lot of time with Eros and Boo (my cats), cook, and make puns/dad jokes whenever the opportunity arises!
								</p>
								<p>
									Don't hesitate! Let's work together!
								</p>
								<p className="hide-on-med-only hide-on-small-only">
									(Try clicking the pictures on either side and see what happens!)
								</p>
								</div>
							</div>
							<div className="col l3 hide-on-med-only hide-on-small-only valign-wrapper">
								<img src="/assets/img/erosboo.jpg" alt="" className={this.state.erosboo?"circle responsive-img animated infinite rotate360":"circle responsive-img"} name="erosboo" onClick={this.handleClick} />
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}
}

export default AboutMe;


// WEBPACK FOOTER //
// ./src/components/AboutMe/AboutMe.js